import React from "react";
import { Navigate } from "react-router-dom";
import Loading from "../Common/Loading";
import { useSellerAuth } from "../Common/SellerAuthContext";

export default function SellerPublicRoute({ children }) {
  const { isSellerAuthenticated, sellerLoading } = useSellerAuth();

  if (sellerLoading) {
    return <Loading />;
  }

  if (isSellerAuthenticated) {
    return <Navigate replace to="/dashboard" />;
  }

  return children;
}
